define.alias("shared/modifiers/autoresize", "calendar/modifiers/autoresize");